<template lang="pug">
  include ../../../views/desktop/shared/iconMixins.pug
  .log-out-section.section.text-left
    button.log-out-button.btn-link.color-slate.xs-f-medium.max-at-tweak(@click="$root.logOut()")
      +icon-logout.xs-f-xmedium.max-at-tweak
      | &nbsp;Log out

</template>

<script>
  export default {
    name: 'LogOutSection'
  }  
</script>

<style scoped lang="stylus">
  .log-out-section
    position relative
    padding 0 !important
    
    .log-out-button
      width 100%
      height 100%
      padding 1.5em 5%
      text-align left
      
      .svg-icon
        margin-right 0.5em
      
</style>
